import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "index-sections" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"section-header\"><h2 class=\"section-title\">Latest <span class=\"gradient-text\"> videos</span></h2><a href=\"videos\" class=\"section-link\"><p class=\"view-link\">View all videos <i class=\"fa fa-arrow-circle-o-right\" aria-hidden=\"true\"></i></p></a></div>", 1)
const _hoisted_3 = { class: "flex-wrapper" }
const _hoisted_4 = { class: "index-sections" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"section-header\"><h2 class=\"section-title\">Latest <span class=\"gradient-text\"> articles</span></h2><a href=\"articles\" class=\"section-link\"><p class=\"view-link\">View all articles <i class=\"fa fa-arrow-circle-o-right\" aria-hidden=\"true\"></i></p></a></div>", 1)
const _hoisted_6 = { class: "flex-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VideoComponent = _resolveComponent("VideoComponent")!
  const _component_ArticleComponent = _resolveComponent("ArticleComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoData?.slice(0, _ctx.videoCount), (video) => {
          return (_openBlock(), _createBlock(_component_VideoComponent, {
            key: video.id,
            title: video.title,
            youtubeid: video.id,
            small: true
          }, null, 8, ["title", "youtubeid"]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articleData.slice(0, _ctx.articleCount), (article) => {
          return (_openBlock(), _createBlock(_component_ArticleComponent, {
            key: article.title,
            title: article.title,
            img: article.img,
            articleurl: article.url,
            desc: article.subTitle,
            small: true
          }, null, 8, ["title", "img", "articleurl", "desc"]))
        }), 128))
      ])
    ])
  ], 64))
}